export default {
  company: {},
  company_types: [],
  branches: [],
  current_branch: {},
  current_branch_employees: [],
  current_sidebar_items: [],
  current_payments: [],
  current_payments_order: [],
  currentPaymentsPages: 0,
  currentTotalAmountRubles: 0,
  currentSuccessAmountRubles: 0
}
